/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {AvatarModule} from 'primeng/avatar';
import {ButtonModule} from 'primeng/button';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DialogModule} from 'primeng/dialog';
import {MenuModule} from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {RippleModule} from 'primeng/ripple';
import {ToolbarModule} from 'primeng/toolbar';
import {GmPrimaryButtonDirective} from '../shared/ui/gm-compat/gm-button-intent.directive';
import {FooterComponent} from './footer/footer.component';
import {HeaderComponent} from './header/header.component';
import {HomeComponent} from './home/home.component';
import {NavToMenuItemPipe} from './navigation/nav-to-menuitem.pipe';
import {NavigationComponent} from './navigation/navigation.component';
import {UserSessionTimeoutComponent} from './user-session-timeout/user-session-timeout.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        AvatarModule,
        ButtonModule,
        ConfirmDialogModule,
        DialogModule,
        MenuModule,
        MenubarModule,
        RippleModule,
        ToolbarModule,
        GmPrimaryButtonDirective,
    ],
    declarations: [
        FooterComponent,
        HeaderComponent,
        HomeComponent,
        NavToMenuItemPipe,
        NavigationComponent,
        UserSessionTimeoutComponent,
    ],
    exports: [
        FooterComponent,
        HeaderComponent,
        HomeComponent,
        NavToMenuItemPipe,
        NavigationComponent,
        UserSessionTimeoutComponent,
    ]
})
export class LayoutModule {
}
